export const main = {
	yhxm:'用戶姓名',
	qrxx:'確認資訊填寫',
    mmdl:'密碼登入',
    yzmdl:'驗證碼登入',
    sjhm:"手機號碼",
    qsrmm:'請輸入密碼',
    wjmm:'忘記密碼',
    dl:'登入',
    zcxzh:'註冊新帳號',
    yzm:'驗證碼',
    hqyzm:'獲取驗證碼',
    sryx:'輸入信箱',
    zcsrmm:'再次輸入密碼',
    yqm:'請輸入邀請碼 / 邀請人手機號碼	',
    sjyz:'手機驗證',
    yxyz:'信箱驗證',
    tyxyhzc:'我同意用戶協議和隱私政策',
    ty:'我已閱讀並同意',
    yhxy:'用戶協議',
    yszc:'隱私政策',
    zce:'註冊',
    zyzhljdl:'已有帳號，立即登入',
    wdzc:'我的資產',
    wdzh:'我的帳戶',
    tbgl:'同步管理',
    fbxh:'發布信號',
    xhsc:'信號市場',
    czsc:'操作手冊',
    tcxh:'退出信號',
    ye:'餘額',
    jz:'淨值',
    jyss:'交易手數',
    ccyl:'持倉盈利',
    xvh:'序號',
    sftb:'是否同步',
    fwq:'伺服器',
    zh:'帳號',
    zyk:'總盈虧',
    kds:'開單數',
    zhzt:'帳號狀態',
    cz:'操作',
    s:'是',
    f:'否',
    zc:'正常',
    yc:'異常',
    ck:'查看',
    cpyk:'產品盈虧',
    zss:'總手數',
    jypz:'交易品種',
    sy:'收益',
    sszb:'手數占比',
    cczh:'持倉彙總',
    ddh:'訂單號',
    jyl:'交易量',
    kcsj:'開倉時間',
    kcjg:'開倉價格',
    bjjg:'標記價格',
    zyzs:'止盈/止損',
    gylx:'隔夜利息',
    yk:'盈虧',
    xzcksj:'請在帳戶中選擇要查看的數據',
    tbyk:'同步盈虧',
    ccsj:'持倉時間',
    pcsj:'平倉時間',
    tjzh:'新增帳戶',
    bz:'備註',
    sfwxh:'是否為信號',
    tbzt:'同步狀態',
    ytb:'已同步',
    wtb:'未同步',
    qyjy:'啟用/停用',
    yqy:'已啟用',
    yjy:'已停用',
    xgzhmm:'修改密碼',
    gbxh:'關閉信號',
    sczh:'刪除帳號',
    qw:'前往',
    y:'頁',
    tjglzh:'新增關聯帳戶',
    qxz:'請選擇',
    qsrzh:'請輸入帳號',
    mm:'密碼',
    qsrbz:'請輸入備註',
    sjsqxhts:'真實帳戶主密碼授權可升級成為社群信號',
    qr:'確認',
    qx:'取消',
    zhjy:'帳號 ***** 是否將其設定為停用狀態',
    zhqy:'帳號 ***** 是否將其設定為啟用狀態',
    dqdlmm:'目前登入密碼',
    xzhmm:'新帳號密碼',
    qrxmm:'確認新密碼',
    qsrdqdlmm:'請輸入目前登入密碼',
    qsrxmm:'請輸入新密碼',
    qzcsrxmm:'請再次輸入新密碼',
    yhzl:'用戶資料',
    jcxx:'基礎資訊',
    tx:'頭像',
    sczp:'上傳照片',
    tudxxz:'請選擇圖片上傳：大小 413*626 畫素，支援 JPG、PNG 等格式，圖片需小於 2M',

	
    gjhdq:'國家和地區',
    dzyx:'電子信箱',
    bcxg:'儲存修改',
    zhaq:'帳號安全',
    dqmm:'目前密碼',
    xmm:'新密碼',
    qrmm:'確認密碼',
    qsrdqmm:'請輸入目前密碼',
    qd:'確定',
    tjtb:'新增同步',
    tb:'同步',
    xh:'信號',
    qsrnr:'請輸入內容',
    tbzh:'同步帳號',
    qxztbzh:'請選擇同步帳號（多選）',
    jygz:'交易規則',
    bzjdb:'保證金等比',
    jzdb:'淨值等比',
    kyzjdb:'可用資金等比',
    jyldb:'交易量等比',
    gdssdb:'固定手數等比',
    jycs:'交易參數',
    kcjybc:'開倉價優補償',
    xhsxzdpc:'信號失效自動平倉',
    zdss:'最大手數',
    zdhc:'最大回撤',
    jsbz:'均以國際標準合約為計算標準（貨幣對國際標準合約 100000；黃金國際標準合約 100 盎司；白銀國際標準合約 5000 盎司；原油國際標準合約 1000 桶)',
    pctbts:'部分平倉以及平倉被操作 基於不同平台終端的操作規則不同，同步過程暫不支援 煩請知悉',
    tbxh:'同步信號',
    tbms:'同步模式',
    tbxs:'同步係數',
    tbsz:'同步設定',
    xgcs:'修改參數',
    yzttb:'已暫停同步',
    ykqtb:'已開啟同步',
    sctb:'删除同步',
    xgtbcs:'修改同步參數',
    cgtbzt:'修改同步狀態',
    sfqkzhdtb:'是否 開啟 目前帳號 ******* 的同步操作？',
    sfztzhdtb:'是否 暫停 目前帳號 ******* 的同步操作？',
    tjxh:'新增信號',
    nsyl:'年收益率',
    zt:'狀態',
    dyz:'訂閱者',
    kstbsj:'開始同步時間',
    zwsj:'暫無數據',
    xzzh:'選擇帳號',
    qxzzh:'請選擇帳號',
    qqdxhhtbzzt:'請確定您的信號和同步者的現狀，以免出現無限循環風險',
    xhm:'信號名',
    qsrxhm:'請輸入信號名（最多十五個字元）',
    xhmts:'信號名：一個帳戶對應一個信號名，一旦確認將不可更改',
    gszzdjz:'跟隨者最低淨值',
    sfgkxh:'是否公開信號',
    gk:'公開',
    sm:'私密',
    gsddzs:'跟隨訂單註釋',
    gsddzsts:'您在此處填寫的內容將顯示在所有跟隨者的 MT 訂單註釋處',
    jdzyjgyhkf:'僅對專業 / 機構用戶開放',
    xhms:'信號描述',
    shili:'示例：該帳戶主做短線，日內單，單單帶止盈止損，建議 2000 美金手數 1:1 同步！',
    clmsts:'為了保護所有用戶的隱私，策略描述裡不允許包含任何聯繫方式',
    xhlb:'信號列表',
    xhlbts:'註：信號提供者均為第三方用戶，同步服務可能會出現延遲，所有交易數據均採集自 MT4/MT5 伺服器',
    xhy:'信號源',
    zongsyl:'總收益率',
    zhousyl:'週收益率',
    jqtjycs:'近 7 天交易次數',
    irrqzsy:'IRR 權重收益',
    zdhc2:'最大回撤（%）',
    zq:'週期（天）',
    jbsj:'基本數據',
    fx:'分享',
    sc:'收藏',
    ysc:'已收藏',
    zsy:'總收益',
    zrj:'總入金',
    zcj:'總出金',
    zdhcl:'最大回撤率（值）',
    zdfk:'最大浮虧',
    zdds:'總訂單數',
    dbzdjyl:'單筆最大交易量',
    t:'天',
    zhhbdw:'帳戶貨幣單位',
    ckqb:'查看全部',
    anyue:'按月',
    jidu:'季度',
    bannian:'半年',
    yinian:'1年',
    ernian:'2年',
    sanian:'3年',
    jzye:'淨值 / 餘額（$）',
    crj:'出入金（$）',
    cj:'出金',
    rj:'入金',
    ysyl:'月收益率',
    yiyue:'1月',
    eryue:'2月',
    sanyue:'3月',
    siyue:'4月',
    wuyue:'5月',
    liuyue:'6月',
    qiyue:'7月',
    bayue:'8月',
    jiuyue:'9月',
    shiyue:'10月',
    shiyiyue:'11月',
    shieryue:'12月',
    ccxj:'持倉細節',
    cq:'產品',
    dk:'多/空',
    ss:'手數',
    yk2:'盈 / 虧',
    hlzb:'衡量指標',
    ylddcxsjpj:'盈利訂單持倉時間',
    ksddcxsjpj:'虧損訂單持倉時間',
    dgddylpj:'單個訂單盈利',
    dgddkspj:'單個訂單虧損',
    dgddlrzd:'單個訂單利潤',
    dgddkszd:'單個訂單虧損',
    syl:'收益率',
    sjbl:'數據比例',
    sl:'勝率',
    zdjybl:'自動交易比率',
    pcddmx:'平倉訂單明細',
    pcjg:'平倉價格',
    sxf:'手續費',
    tbxtccsc:'同步系統操作手冊',
    zhzc:'帳號註冊',
    xtdl:'系統登入',
    jzhszwxh:'將帳號設定為信號？',
    sztbxh:'設定同步信號', 
	
	
    wzjs:"JCLH将MT4或MT5下跨交易商多账户集中在平台内进行垂直管理，并为用户提供全部账户的数据汇聚、风险分析、财务汇总、信息分享和账户间数据同步的服务。",
    mzsmText:`<p  style="font-weight: bold; color: windowtext; text-align: center; ">
		<strong><span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
		免责声明</span>
		</strong>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明是由 JCLH与在网站www.JCLH.biz上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		   <span>
				
				本网站已采取谨慎的措施对信息进行核实，但并不保证所含信息全部准确。请您理解我们的信息可能会不全面，或有疏漏或滞后。本网站或独立信息提供者均不会对任何因信息错误、不完整、迟延、不精确或基于对本网站信息的依赖而产生的损失承担任何责任。所有预测或观点(如未来汇率变动的预测)以及基于这些预测而进行的交易活动，仅代表第三方的个人观点和行为，并不代表本网站的立场。您须理解，第三方的预测不代表任何形式的业绩承诺，请不要直接或者间接地效仿。您必须进行独立分析以做出投资判断，同时应了解，在基于本网站内容做出判断所进行的投资行为可能产生实际的盈利或亏损。您基于本网站提供的交易策略和信号，运用个人配置交易系统所做出的投资行为是您自己决定的结果，需自行承担所有风险。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
		  
				
				本网站明确表明，本网站的管理平台仅适用于对高风险投资有一定了解的用户。您可以使用空闲的资金进行投资，而不应该影响到日常生活的开支。任何交易策略在过去取得的业绩均不能代表其将来的表现。一般未来汇率变动是不可预测的，这也就表明任何个人策略、金融顾问、手动或者自动交易系统都不能保证任何形式的预测可能产生利润，所以对待投资预测一定要经过自己的分析做出判断，切忌盲从。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;"><span>基于网站或网络传输延时可能导致数据存在偏差（包括但不限于可能由于交易员修改密码或其他网络原因导致的账户断连造成订单跟随关系丢失），因此，用户在使用交易系统、交易跟随系统形成、产生交易后，应及时查看交易系统中交易数据的变化。无论是 JCLH 或是本网站任何合作伙伴都不能保证，您基于 JCLH 提供的信息及使用个人配置交易系统进行投资一定会盈利。除此之外， JCLH 作为跟随交易系统的开发者，不会对任何由于第三方(如作为这项服务的提供者公司或者交易商)延误、疏忽而导致的客户损失承担责任。除了以上， JCLH 明确表明不会对交易员提供的策略和交易信号承担任何责任。</span></span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				JCLH 所属公司注册所在地法律、法规应适用于本声明以及管辖本声明各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
			
				在合约一方寻求实现本声明下的权利，或寻求宣告本声明下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。
			   
			</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">本声明的解释语言应为中文。</span>
		</p>
		<p  style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
	`,
    yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
			<strong>
				<span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
					隐私政策
				</span>
			</strong>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1. 我们收集的信息类型
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				我们主要收集三类信息。
			</span>
		</p>

		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				1.1 您向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				使用 JCLH 的必要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

				当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.1 账号信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.1.2 您选择向我们提供的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				交易风控信息。您可选择提供设置账户交易时使用的风控策略。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.2 您使用 JCLH 时，我们自动收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Cookies 及类似技术。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				1.3 我们通过第三方收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如：交易商信息、账户名、只读密码、交易数据等）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.我们如何使用所收集的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				2.1 创建和维护一个受到信任的以及更安全的环境
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				检测和预防欺诈、滥用、安全事件及其他有害活动。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				开展安全调查和风险评估。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				遵守我们的法律义务。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				执行我们的服务条款及其他政策。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.分享与披露
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.1 征得您的同意
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.2 业务转移
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				3.3汇总信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.其他重要信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				4.1 关联第三方账号
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.您的权利
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.1 管理您的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.2 不准确或不完整的信息
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				5.4 数据保留与删除
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				请注意，如果您申请删除您的个人信息：
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				6. 全球运营
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				7.安全
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				8.本《隐私政策》的变更
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				9.联系我们
			</span>
		</p>
		<p style=" color: windowtext; text-align: left; ">
			<span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
				如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
			</span>
		</p>
	`,
	fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
		<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.biz 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户：中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
		</p>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
		</p>
		<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
		</h1>
		<p  style=" color: #ffffff; text-align: left; ">
		<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
		</p>
		<p>
		<br/>
	</p>`,
	
	
	
    mzsmbt:"免責聲明",
	qwzxcz:"為保證帳號跟單收益，請勿自行操作!",
	wdzl:"我的資料",
	wdqb:"我的錢包",
	hyfw:"會員服務",
	wdtd:"我的團隊",
	tcdl:"退出登入",
	xhgl:"信號管理",
	sfgz:"收費規則：以資金和信號資金 1:1 為基礎定價；用戶訂閱費動態更新、按天扣除。",
	jcdyf:"基礎訂閱費",
	yhdyf:"用戶訂閱費",
	zhye:"帳戶餘額",
	xhye:"信號餘額",
	yf:"月",
	bkxzjygz:"目前不可選擇交易規則",
	bksrjycs:"目前不可輸入交易參數",
	hand:"手",
	pcjl:"平倉記錄",
	tdxx:"團隊資訊",
	wdyqm:"我的邀請碼",
	fz:"複製",
	yqmsjh:"推薦邀請碼 / 手機號碼	",
	bangd:"綁定",
	agree:"我同意",
	mzsm:"免責聲明",
	and:"和",
	fwtk:"服務條款",
	qhyy:"切換語言",
	zhong:"中文",
	ying:"英文",
	wei:"維語",
	tai:"泰语",
	han:"韓語",
	ri:"日語",
	
	kyye:"可用 JCLHoin 餘額",
	yets:"JCLHoin 是一種代幣，只可以在 JCLH 社群使用，用戶之間不能轉讓，不能贖回。由 JCLH 營運。透過購買點數兌換獲得。 JCLHoin 可用於支付訂閱費，兌換獎品和其他站內行為。詳情參閱《JCLHoin 購買與使用協議》",
	zffs:"支付方式",
	
	szhb:"數位貨幣",
	wxzf:"微信支付",
	zfb:"支付寶",
	yl:"銀聯",
	xyk:"信用卡",
	szjl:"收支記錄",
	
	szsj:"時間",
	szsl:"數量",
	szxm:"項目",
	szzt:"訂單狀態",
	szbh:"訂單編號",
	
	dqdj:"目前等級",
	yxq:"有效期至",
	shengj:"升級",
	hygm:"歡迎購買 JCLH 會員",
	zfje:"支付金額",
	xfjl:"消費記錄",
	xfje:"金額",
	
	dzgl:"關聯",
	dzg:"個",
	dzzh:"帳戶",
	
	a1:'購買數量',
	a2:'會員等級',
	a3:'帳號數量',
	a4:'操作',
	a5:'待上傳憑證',
	a6:'支付成功',
	a7:'支付失敗',
	a8:'上傳憑證',
	a9:'查看支付',
	a10:'支付',
	a11:'數位貨幣',
	a12:'錢包地址',
	a13:'複製地址',
	a14:'複製錢包地址至進行支付',
	a15:'二維碼',
	a16:'金額',
	a17:'確定',
	a18:'取消',
	a19:'關閉',
	a20:'複製成功',
	a21:'上傳憑證',
	a22:'查看憑證',
	a23:'待審核',
	a24:'保證金等比',
	a25:'淨值等比',
	a26:'可用資金等比',
	a27:'交易量等比',
	a28:'固定手數等比',
	a29:'反向跟單',
	a30:'開倉補償',
	a31:'平倉補償',
	a32:'已選',
	a33:'是否開啟目前帳號',
	a34:'是否暫停目前帳號',
	a35:'同步操作',
	a36:'限定一個帳號',
	a37:'不限購買帳號數量',
	
	a38:'試用版會員',
	a39:'基礎版會員',
	a40:'專業版會員',
	a41:'機構版會員',
	a42:'請設定手機號碼',
	a43:'請設定郵箱',
	a44:'請輸入邀請碼',
	a45:'上傳頭像圖片只能是 JPG 格式！',
	a46:'上傳頭像圖片大小不能超過 2MB!',
	a47:'暫無同步數據',
	a48:'總手數',
	a49:'是否將其置為',
	a50:'啟用',
	a51:'禁用',
	a52:'狀態',
	a53:'確認要刪除此帳號嗎',
	a54:'已複製！',
	
	a55:'請輸入交易參數',
	a56:'新密碼與確認密碼不一致！',
	a57:'日收益',
	a58:'平均',
	a59:'最大',
	a60:'刷新成功',
	a61:'生產率',
	a62:'不合格',
	a63:'合格',
	a64:'勝率',
	a65:'出金',
	a66:'入金',
	a67:'餘額',
	a68:'淨值',
	a69:'日盈虧',
	a70:'請輸入數值',
	a71:'該信號暫無同步者',
	
	a72:'登錄狀態已過期，請重新登錄！',
	a73:'簡訊已發送，請注意查收.',
	a74:'驗證碼已發送！',
	a75:'登錄成功！',
	a76:'用戶姓名不能為空',
	a77:'手機號碼不能為空',
	a78:'未同意用戶協議和隱私政策',
	a79:'會員升級',
	a80:'選擇類型',
	a81:'當前有效期至',
	a82:'折算有效期至',
	a83:'註：折算後的有效期是系統自動計算得出。',
	a84:'將文件拖到此處',
	a85:'或',
	a86:'點擊上傳',
	a87:'您已是最高等級會員，無法繼續升級.',
	a88:'審核中',
	a89:'暫不支持此支付方式',
	a90:'重置密碼',
	a91:'想起来了',
	a92:'美國',
	a93:'中國',
	a94:'香港',
	
	a95:'風險提醒',
	a96:'本智慧量化社群主要提供標準化交易信號，供用戶參考使用。',
	a97:'為確保策略有效性並控制執行偏差',
	a98:'建議單個量化標的之資金規模不低於 20000 USD',
	a99:'若投入資金低於該基準，可能因資金規模不足而放大相對風險，影響策略穩定性',
	a100:'請您在開始任何操作前，務必根據自身財務狀況和風險承受能力',
	a101:'自行設置帳戶的風險保護機制',
	a102:'所有量化交易行為均為您個人獨立決策，相關盈虧及因市場波動、系統故障、政策變動等不可抗力因素所導致的損失',
	a103:'均由您本人承擔',
	a104:'本社群所提供的信號僅作資訊參考',
	a105:'不構成投資建議、要約或擔保',
	a106:'本智慧量化社群',
	a107:'不對任何交易結果或資金損失承擔責任',
	a108:'請充分理解並確認接受上述風險後再進行操作',
	a109:'我已了解',
	
	zhlb:'賬戶列表',
	
	a110:'暫無等級',
}
